import React from 'react'
import './loader.scss'

const Loader = () => {
   return (
    <div className='loader_wrapper' ><span></span></div>
   )
}

export { Loader }